import React from "react";
import styles from "../UploadImageQR.module.scss";
import classnames from "classnames";
import UploadMultipleImageBoxes from "./UploadMultipleImageBoxes.jsx";
import UploadMultipleImageIntroText from "./UploadMultipleImageIntroText.jsx";
import UploadMultipleImageFileInputButton from "./UploadMultipleImageFileInputButton.jsx";

export default function UploadMultipleImagePhonePart({ appProps, multipleImageQrProps }) {
    const { uploadButtonTextPhone, secondaryColorCss, qrCodeValue } = multipleImageQrProps;
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <UploadMultipleImageIntroText multipleImageQrProps={multipleImageQrProps} className={classnames(styles["intro-text-phone"], secondaryColorCss)} />
                <UploadMultipleImageFileInputButton multipleImageQrProps={multipleImageQrProps} htmlUploadId={"file-upload-phone-" + qrCodeValue} uploadButtonText={uploadButtonTextPhone} />
            </div>
            <UploadMultipleImageBoxes appProps={appProps} multipleImageQrProps={multipleImageQrProps} />
        </div>
    );
}
